import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const checkoutMetric = z.object({
  title: z.string(),
  valuesByTreatment: z.array(
    z.object({
      treatmentId: zExt.objectId(),
      value: z.string(),
      highlightMetric: z.boolean().optional(),
    }),
  ),
});
export type CheckoutMetric = z.infer<typeof checkoutMetric>;

const orderValueFilterSchema_ = z.object({
  minOrderValue: z.number().nonnegative().optional(),
  maxOrderValue: z.number().positive().optional(),
});
export const orderValueFilterSchema: z.ZodType<OrderValueFilter> =
  orderValueFilterSchema_;
export interface OrderValueFilter
  extends z.infer<typeof orderValueFilterSchema_> {}

export const getAllCheckoutSplitMetrics = {
  name: "getAllCheckoutSplitMetrics" as const,
  input: z.object({
    splitId: zExt.objectId(),
    orderValueFilter: orderValueFilterSchema_.optional(),
  }),
  output: z.object({
    allTreatmentIds: z.array(zExt.objectId()),
    checkoutMetrics: z.array(checkoutMetric),
    orderValueFilterApplied: z.boolean().optional(),
    excludedOrderCount: z.number().optional(),
    totalOrderCount: z.number().optional(),
  }),
};
